import axiosInstant from "../../axiosInstant";

// Generic error handler
const handleResponse = (promise) =>
  promise
    .then((res) => res.data)
    .catch((error) => error?.response?.data || { success: false, error });

export async function auctionsLive() {
  return handleResponse(axiosInstant.get(`declarator/current`));
}

export async function postStatus(data) {
  return handleResponse(axiosInstant.post(`declarator/lot/update_status`, data));
}

export async function floorBidPost(data) {
  return handleResponse(axiosInstant.post(`declarator/bid/floor`, data));
}

export async function phoneBid(data) {
  return handleResponse(axiosInstant.post(`declarator/bid/phone`, data));
}

export async function hallBid(data) {
  return handleResponse(axiosInstant.post(`declarator/bid/hall`, data));
}

export async function postUndo(data) {
  return handleResponse(axiosInstant.post(`declarator/lot/undo`, data));
}

export async function declaratorNextImage(data) {
  const { auction_id, setId, LotNo } = data;
  return handleResponse(
    axiosInstant.get(
      `live/lot/next?auction_id=${auction_id}&setId=${setId}&lot_number=${LotNo}`
    )
  );
}

export async function nextLot(data) {
  return handleResponse(axiosInstant.post(`declarator/lot/next_lot`, data));
}

export async function postMessage(message) {
  return handleResponse(
    axiosInstant.post(`declarator/announcement`, { msgs: message })
  );
}

export async function nextAuction(LiveData, data) {
  const { auction_details, lot } = LiveData;
  const nextLotNumber =
    data?.nextCount != null
      ? data.nextCount + 1
      : parseInt(lot.details?.[0]?.lot_number || 0) + 1;

  return handleResponse(
    axiosInstant.get(
      `declarator/lot/next?auction_id=${auction_details.auction_id}&setId=${auction_details.id}&lot_number=${nextLotNumber}`
    )
  );
}
